export const usersPreferenceCenters = "/users/preference_centers";
